export const ACTIVE = "Activated";
export const EXPIRED = "Expired";
export const INACTIVE = "Inactive";
export const PENDING = "Pending";
export const REGISTERED = "Registered";